export default __webpack_public_path__ + "static/media/background_indoor.d6dafc66.jpg";